import CoordinatorScreen from "./CoordinatorScreen";

export default CoordinatorScreen;
